// extracted by mini-css-extract-plugin
module.exports = {"container":"License_container__QI4GE","header":"License_header__2PvZF","form":"License_form__2cUNC","actions":"License_actions__1uNSA"};